/**
 * Typed wrappers around the Atlas Cloud Functions callables (doc 147 §8.4).
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from './client.js';
import type { InternalUser } from '../state/store.js';

export interface SetUserRoleRequest {
  uid: string;
  role: InternalUser['role'];
}

export interface SetUserRoleResponse {
  uid: string;
  role: InternalUser['role'];
}

/* c8 ignore start — thin httpsCallable wrapper; emulator/manual tested. */

/** Admin-only: assign a role to an internal user (calls `setUserRole`). */
export async function callSetUserRole(req: SetUserRoleRequest): Promise<SetUserRoleResponse> {
  const fn = httpsCallable<SetUserRoleRequest, SetUserRoleResponse>(functions, 'setUserRole');
  const result = await fn(req);
  return result.data;
}

/* c8 ignore stop */
